import * as actionTypes from '../actions/actionTypes';
import { produce } from 'immer';
import { fastEqual } from '../../../../utils/fastDeepEqual';

const initialState = {
  tickets: [],
  loading: false,
  loaded: false,
  tournaments: {},
};

const pokerTournamentTicketsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case actionTypes.poker.POKER_TRT_LOADED: {
        if (!fastEqual(draft.tickets, action.tickets)) {
          // don't update if they're the same
          draft.tickets = action.tickets;
        }
        draft.loading = false;
        draft.loaded = true;
        break;
      }
      case actionTypes.poker.POKER_TRT_LOADING: {
        draft.loading = action.status;
        draft.loaded = false;
        break;
      }
      case actionTypes.poker.POKER_TRT_FETCH_TOURNAMENTS_BY_TOURNAMENT_TYPES_LOADED: {
        // This action is used to fetch tournaments by a specific ticket (tournament IDS)
        // console.log('[pokerTournamentTicketsReducer] POKER_TRT_FETCH_TOURNAMENTS_BY_TOURNAMENT_TYPES_LOADED', action.data);
        draft.tournaments[action.data.trt] = action.data.tournaments ?? [];
        draft.loading = false;
        draft.loaded = true;
        break;
      }

      default:
        break;
    }
  });

export default pokerTournamentTicketsReducer;
